module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('GChart', {
    attrs: {
      "settings": _vm.chartSettings,
      "type": "Gauge",
      "data": _vm.chartData,
      "options": _vm.chartOptions,
      "resizeDebounce": 500
    }
  })
},staticRenderFns: []}